/* IMBRIUM sticky mobile add-to-cart bar — vanilla, no imports (Shopify-safe). */
(function () {
  function initBar(bar) {
    var sectionId = bar.getAttribute('data-section');
    var scope = document.getElementById('MainProduct-' + sectionId) || document;
    var mainBtn = scope.querySelector('.product-form__submit') ||
                  scope.querySelector('button[name="add"]');
    var buyArea = scope.querySelector('.product-form__buttons') || mainBtn;
    if (!mainBtn || !buyArea) return;

    var priceEl = document.getElementById('price-' + sectionId);
    var stickyPrice = bar.querySelector('[data-sticky-price]');
    var addBtn = bar.querySelector('[data-sticky-add]');
    var addLabel = addBtn.querySelector('span') || addBtn;

    // Forward taps to the real ATC button → uses the selected variant + AJAX cart.
    addBtn.addEventListener('click', function () {
      if (mainBtn.disabled) {
        buyArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainBtn.click();
    });

    function sync() {
      if (priceEl && stickyPrice) {
        var p = priceEl.querySelector('.price-item--sale:not(.hidden), .price-item--regular, .price-item');
        if (p && p.textContent.trim()) stickyPrice.textContent = p.textContent.trim();
      }
      addBtn.disabled = mainBtn.disabled;
      var mainLabel = mainBtn.querySelector('span');
      if (mainLabel && mainLabel.textContent.trim()) addLabel.textContent = mainLabel.textContent.trim();
    }

    var inView = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { inView = e.isIntersecting; });
        update();
      }, { threshold: 0 }).observe(buyArea);
    }

    function tallEnough() {
      return document.documentElement.scrollHeight > window.innerHeight * 1.6;
    }
    function update() {
      if (!inView && tallEnough()) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    }

    // Re-sync price/label when the variant changes (Dawn updates #price + the button).
    if (priceEl && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(priceEl, { subtree: true, childList: true, characterData: true });
    }
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(mainBtn, { attributes: true, childList: true, subtree: true });
    }
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('scroll', update, { passive: true });

    sync();
    update();
  }

  function init() { document.querySelectorAll('.im-sticky-atc').forEach(initBar); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
